import Default from '@/assets/img/avatar/default.svg'
import Boy1 from '@/assets/img/avatar/boy1.svg'
import Boy2 from '@/assets/img/avatar/boy2.svg'
import Boy3 from '@/assets/img/avatar/boy3.svg'
import Boy4 from '@/assets/img/avatar/boy4.svg'
import Boy5 from '@/assets/img/avatar/boy5.svg'
import Girl1 from '@/assets/img/avatar/girl1.svg'
import Girl2 from '@/assets/img/avatar/girl2.svg'
import Girl3 from '@/assets/img/avatar/girl3.svg'
import Girl4 from '@/assets/img/avatar/girl4.svg'
import Girl5 from '@/assets/img/avatar/girl5.svg'
import Girl6 from '@/assets/img/avatar/girl6.svg'

export const avatars = [
  { name: 'default', icon: Default },
  { name: 'boy1', icon: Boy1 },
  { name: 'boy2', icon: Boy2 },
  { name: 'boy3', icon: Boy3 },
  { name: 'boy4', icon: Boy4 },
  { name: 'boy5', icon: Boy5 },
  { name: 'girl1', icon: Girl1 },
  { name: 'girl2', icon: Girl2 },
  { name: 'girl3', icon: Girl3 },
  { name: 'girl4', icon: Girl4 },
  { name: 'girl5', icon: Girl5 },
  { name: 'girl6', icon: Girl6 },
]

export const getAvatarIcon = (iconName: string | undefined) => {
  return avatars.find((a) => a.name === iconName)?.icon
}

export const getAvatarFromIconName = (iconName?: string) => {
  return avatars.find((a) => a.name === iconName) || avatars[0]
}
